module.exports = "<p>\n  {{'LOGOUT.LOGOUT_CONFIRMATION' | translate}}\n\n  <button (click)=\"onLogout($event)\">{{'LOGOUT.LOGOUT' | translate}}</button>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/logout/logout.component.html
// module id = 1DO0
// module chunks = 0